import type { SelectableFieldTypes, ValidationRule } from './types';

// Sourced from cms-web packages/auto-cms-field-types/src/field-types-metadata.json validations[] per type.
//
// TODO: cross-check this map against cms-web before GA. The ValidationSection UI in Phase 3 renders
// rule inputs based on this map — a wrong entry surfaces as the wrong set of inputs for a field type.
// Updating this file is the single place to fix any mismatch; no downstream changes required.
const fieldValidationRulesMap: Record<SelectableFieldTypes, ValidationRule[]> =
  {
    SHORT_TEXT: ['required', 'charactersLimit'],
    NUMBER: ['required'],
    BOOLEAN: ['required'],
    DATE: ['required'],
  };

export const getFieldTypeValidationRulesList = (
  t: SelectableFieldTypes,
): ValidationRule[] => fieldValidationRulesMap[t] ?? [];
